import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { WalletProvider } from "./providers/wallet-context";
import { AuthProvider } from "./providers/auth-context";
import { RouterProvider } from "react-router";
import { routes } from "./routes";
import StructuredData from "./components/seo/structured-data";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "./core/errors";
import "react-toastify/dist/ReactToastify.css";
import "@/styles/custom-toast.css";
// import "@/styles/toast-icons.css"; // Alternative approach with mask images

type AxiosErrorWithResponse = AxiosError<{ message: string }>;

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (count, error) => {
          const axiosError = error as AxiosErrorWithResponse;
          const statusCode = axiosError.response?.status;
          if (count >= 2) return false;
          if (statusCode) {
            if (statusCode >= 400) {
              return false;
            }
          }
          return true;
        },
        retryDelay: 0,
      },
    },
  });

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <WalletProvider>
          <AuthProvider>
            <RouterProvider router={routes} />
            <StructuredData page={"website"} />
          </AuthProvider>
        </WalletProvider>
        <ToastContainer
          position="top-right"
          stacked
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          closeButton={true}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          autoClose={5000}
          className="custom-toast-container"
        />
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
